import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await register(form.email, form.password, form.name);
    setLoading(false);
    if (res.ok) {
      toast.success(`Welcome, ${res.user.name}`);
      nav("/account");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="pt-32 pb-24 min-h-[80vh] flex items-center justify-center" data-testid="register-page">
      <motion.form
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        onSubmit={submit}
        className="glass-panel rounded-lg p-10 w-full max-w-md"
      >
        <div className="text-center mb-8">
          <div className="text-[10px] tracking-[0.35em] uppercase text-pink-blush mb-3">Behind the velvet rope</div>
          <h1 className="font-display text-4xl text-champagne">
            Join <span className="italic text-pink-hot">Layla</span>
          </h1>
        </div>
        <div className="space-y-3">
          <input required placeholder="Name" value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            data-testid="register-name"
            className="w-full bg-noir-base border border-rosegold/20 px-4 py-3 text-sm rounded-sm focus:border-pink-hot focus:outline-none text-champagne" />
          <input required type="email" placeholder="Email" value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            data-testid="register-email"
            className="w-full bg-noir-base border border-rosegold/20 px-4 py-3 text-sm rounded-sm focus:border-pink-hot focus:outline-none text-champagne" />
          <input required type="password" placeholder="Password (6+)" value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            data-testid="register-password"
            className="w-full bg-noir-base border border-rosegold/20 px-4 py-3 text-sm rounded-sm focus:border-pink-hot focus:outline-none text-champagne" />
          <button
            disabled={loading}
            className="w-full py-3 bg-pink-hot text-white text-xs tracking-[0.3em] uppercase rounded-sm hover:bg-pink-glow glow-pink transition-all disabled:opacity-60"
            data-testid="register-submit"
          >
            {loading ? "Creating..." : "Create Account"}
          </button>
        </div>
        <div className="divider-gold my-6" />
        <div className="text-center text-sm text-champagne/70">
          Already a member?{" "}
          <Link to="/login" className="text-pink-hot pink-underline-link" data-testid="go-login">
            Sign in
          </Link>
        </div>
      </motion.form>
    </div>
  );
}
